module.exports = __webpack_public_path__ + "static/progetto_gioia181-fbe461bed180b8c17b64f2ea49c6f28a.jpg";